<template>
  <div class="live-content">
    <div id="dplayer" />
  </div>
</template>
<script>
import DPlayer from 'dplayer';

export default {
  name: 'FomTitle',
  props: {
    url: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      DPlayer: null,
    };
  },
  mounted() {
    // 初始化
    this.initPlayer();
    // 监听播放事件
  },
  methods: {
    initPlayer() {
      const self = this;
      try {
        this.DPlayer = new DPlayer({
          container: document.getElementById('dplayer'),
          live: true,
          video: {
            url: self.url.pullFlvUrl,
            type: 'flv',
          },
        });
        this.DPlayer.on('error', () => {
          self.$message.error('直播数据加载失败');
        });
        this.DPlayer.on('loadeddata', () => {
          self.$message.success('直播数据加载完毕');
        });
      } catch (e) {
        self.$message.error('直播数据加载失败,请检查推流是否成功');
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.live-content{
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  .dplayer{
    width: 100%;
    max-height: 100%;
  }
}
</style>
